import React, { useState, useEffect } from 'react'
import utils from '../utils/utils';
import { Link, useNavigate } from 'react-router-dom';
import msg from '../utils/msgToask';
import 'react-toastify/dist/ReactToastify.css';
import utilsCarrito from '../utils/utilsCarrito';
import utilsRecervas from '../utils/utilsRecervas';
import Header from './Header';
import PopupLoader from './utils/PopupLoader';
import MsgAlertas from './utils/MsgAlertas';
import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal';

const restricciones_desactivadas = process.env.REACT_APP_RESTRICCIONES_DESACTIVADAS === "true";

export default function RealizarReserva(props) {
  const { setPantalla, setCarrito, carrito, regional } = props;
  const navigate = useNavigate();
  const [nit, setNit] = useState('');
  const [nombre, setNombre] = useState('');
  const [observaciones, setObservaciones] = useState('');
  const [idDespacho, setIdDespacho] = useState(1);
  const [error, setError] = useState({})
  const [listaDespacho, setListaDespacho] = useState([]);
  const [conFactura, setConFactura] = useState(false);
  const [cliente, setCliente] = useState('');
  const [despacho, setDespacho] = useState(false);
  const [tipoPedido, setTipoPedido] = useState('');
  const [generoQr, setGeneroQr] = useState(false);
  const [horaPedido, setHoraPedido] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [alerta, setAlerta] = useState(false);
  const [hayPagoqr, setHayPagoqr] = useState(true);
  const [hayPagoe, setHayPagoe] = useState(true);
  const [telefono, setTelefono] = useState("");
  const [pedidoNormal, setPedidoNormal] = useState(true);
  const [sucursalSeleccionada, setSucursalSeleccionada] = useState("");
  const [sucursales, setSucursales] = useState([]);
  const [mostrarMensajeConfirmacion, setMostrarMensajeConfirmacion] = useState(false);
  const [tipoPago, setTipoPago] = useState("");
  const [horaRegional, setHoraRegional] = useState(false);

  const cancelarTodo = () => {
    localStorage.removeItem('variante');
    localStorage.removeItem('elegido');
    setPantalla(0)
  }

  async function generarCodigoQr(data) {
    console.log(data)
    var info = JSON.parse(localStorage.getItem('recervas'))[0]
    var idSuc = localStorage.getItem('filtroSucursal');
    fetch(`/reservare/generarQr`, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json;charset=utf-8',
      },
      body: JSON.stringify({
        ID_SUCURSAL: idSuc,
        DETALLE: 'Pedido' + info.pedidoNro + utilsRecervas.getNombreSucursal(idSuc),
        MONTO: info.pedido.total, BANCO: 'SCZ', AUX: data
      })
    })
      .then(res => res.json())
      .then(data => {
        setLoading(false);
        if (data.ok) {
          var inf = JSON.parse(localStorage.getItem('infUser'))
          inf.idPagoQr = data.ok;
          localStorage.setItem('infUser', JSON.stringify(inf));
          setGeneroQr(true);
          navigate("/QrPagar", { replace: true });
        } else {
          setGeneroQr(false);
          msg.msgError(data.error);
        }
      })
      .catch(error => msg.msgError(error));
  }
  async function realizarPedido1(pedido, tipo) {
    console.log(pedido);
    var idSucursal = localStorage.getItem('filtroSucursal');
    //var ipServer = utilsRecervas.getIpservidor(idSucursal);
    fetch(`/reservare`, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json;charset=utf-8',
      },
      body: JSON.stringify({
        pedido, idSucursal
      })
    })
      .then(res => res.json())
      .then(data => {
        setLoading(false);
        console.log("respuesta", data);
        if (data.status == 0) {
          let pedidoConRuta = localStorage.getItem('pedidoConRuta');
          let condicion = pedidoConRuta == "true";

          if (tipoPedido === 'DOMICILIO' || tipo == 'Q' || tipoPedido == 'FEXCO') {
            if (data.idPago !== '') {

              let datos;
              if (condicion) {
                let regionalActualizada = localStorage.getItem('ciudad')
                datos = { ...data, "estado": 'P', "ciudad": regionalActualizada }
              } else {
                datos = { ...data, "estado": 'P', "ciudad": regional }
              }

              localStorage.setItem('telefonico', data.idTelefonico);
              utilsRecervas.addRecerva(datos, pedido);
              localStorage.removeItem('carrito');
              localStorage.removeItem('pisoSeleccionado');
              setGeneroQr(true);
              navigate("/QrPagar", { replace: true });
            } else {
              setGeneroQr(false);
              setMessage("Intente Nuevamento no pudimos enviar su pedido !")
              setAlerta(true);
            }
          } else {

            let datos;

            if (condicion) {
              let regionalActualizada = localStorage.getItem('ciudad')
              datos = { ...data, "estado": 'P', "ciudad": regionalActualizada }
            } else {
              datos = { ...data, "estado": 'P', "ciudad": regional }
            }

            localStorage.setItem('telefonico', data.idTelefonico);
            utilsRecervas.addRecerva(datos, pedido);
            localStorage.removeItem('carrito');
            localStorage.removeItem('pisoSeleccionado');
            setLoading(false);
            navigate("/misReservas", { replace: true });
          }
        } else {
          setLoading(false);
          if (data.mensaje !== undefined && data.mensaje !== null) {
            msg.msgError(data.mensaje);
            setMessage(data.mensaje);
            setAlerta(true);
          } else {
            msg.msgError(data.message);
            setMessage(data.message)
            setAlerta(true);
          }
        }
      })
      .catch(error => {
        msg.msgError(error.message);
        setMessage(error.message);
        setAlerta(true);
      });
  }

  async function realizarPedido(pedido, tipo) {
    console.log(pedido);

    var idSucursal = localStorage.getItem('filtroSucursal');
    var idCiudad = localStorage.getItem('ciudad');
    
    try {
      const res = await fetch(`/reservare`, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json;charset=utf-8',
        },
        body: JSON.stringify({ pedido, idSucursal, idCiudad })
      });

      const data = await res.json();
      setLoading(false);
      console.log("respuesta", data);

      if (data.status == 0) {

        let pedidoConRuta = localStorage.getItem('pedidoConRuta');
        let condicion = pedidoConRuta == "true";
        if (tipoPedido === 'DOMICILIO' || tipo == 'Q' || tipoPedido == 'FEXCO') {

          if (data.idPago !== '' && data.idPago !== undefined && data.idPago !== null) {

            let datos;
            if (condicion) {
              let regionalActualizada = localStorage.getItem('ciudad')
              datos = { ...data, "estado": 'P', "ciudad": regionalActualizada }
            } else {
              datos = { ...data, "estado": 'P', "ciudad": regional }
            }

            localStorage.setItem('telefonico', data.idTelefonico);
            utilsRecervas.addRecerva(datos, pedido);
            localStorage.removeItem('carrito');
            localStorage.removeItem('pisoSeleccionado');
            setGeneroQr(true);
            navigate("/QrPagar", { replace: true });
          } else {
            setGeneroQr(false);
            setMessage("Intente Nuevamento no pudimos enviar su pedido !")
            setAlerta(true);
          }

        } else {
          let datos;

          if (condicion) {
            let regionalActualizada = localStorage.getItem('ciudad')
            datos = { ...data, "estado": 'P', "ciudad": regionalActualizada }
          } else {
            datos = { ...data, "estado": 'P', "ciudad": regional }
          }

          localStorage.setItem('telefonico', data.idTelefonico);
          utilsRecervas.addRecerva(datos, pedido);
          localStorage.removeItem('carrito');
          localStorage.removeItem('pisoSeleccionado');
          setLoading(false);
          navigate("/misReservas", { replace: true });
        }

      } else {
        setLoading(false);
        if (data.mensaje !== undefined && data.mensaje !== null) {
          msg.msgError(data.mensaje);
          setMessage(data.mensaje);
          setAlerta(true);
        } else {
          msg.msgError(data.message);
          setMessage(data.message)
          setAlerta(true);
        }
      }
    } catch (error) {
      msg.msgError(error.message);
      setMessage(error.message);
      setAlerta(true);
    }
  }

  function validarCorreo(email) {
    if (email === '' || email.includes('@')) {
      return true
    }
    return false;
  }
  function validarOpenSucursal(suc, hora) {
    var infor = utilsRecervas.getHorarioSucursalRegional(regional, 9);
    var hro = 0, hrc = 0
    if (infor[infor.indexOf(3)] != 0) {
      hro = infor[4];
      hrc = infor[5];
    }
    var info = utilsRecervas.getHorarioSucursal(9)
    var horaIni = info[info.indexOf(suc) + 1];
    var horaFin = info[info.indexOf(suc) + 2];
    var dayminutes = (parseInt(hora[0]) * 60) + parseInt(hora[1]);
    console.log(dayminutes, hro, hrc);
    if ((dayminutes >= horaIni && (hro == 0 || dayminutes >= hro)) && (dayminutes < horaFin && (hrc == 0 || dayminutes < hrc))) {
      return true;
    } else {
      return false;
    }
  }
  function validarHora(hora) {
    if (tipoPedido === 'DOMICILIO') {
      return true;
    } else {
      var horas = hora.split(':');
      var day = new Date()
      if (parseInt(horas[0]) >= day.getHours()) {
        if ((parseInt(horas[0]) * 60) + parseInt(horas[1]) >= (day.getHours() * 60) + day.getMinutes() + 30) {
          return validarOpenSucursal(localStorage.getItem('filtroSucursal'), hora.split(':'))
        } else {
          setMessage("Hora incorrecta, por lo menos tiene que tener 30 minutos de diferencia de la hora actual, gracias !");
          return false
        }
      } else {
        setMessage("Ya son las " + day.getHours() + " Hrs, selecciones la hora igual o mayor gracias.");
        return false;
      }
    }
  }
  const enviarPedido = (dato) => {
    console.log(dato)
    if (telefono !== '') {

      if ((telefono[0] === '7' || telefono[0] === '6' || telefono[0] === '5') && telefono.length === 8) {

        if (nit !== '' && nombre !== '' && nit !== '0' && nit !== '00' && nit !== '000' && nit !== '0000') {

          setTipoPago(dato);
          setMostrarMensajeConfirmacion(true);

        } else {
          if (nit === '') {
            setMessage("Ingrese NIT o CI, para la factura");
            setAlerta(true);
            setError({ noNit: "Ingrese el NIT o CI, para la reserva !!!" })
          } else if (nit === '0' || nit === '00' || nit === '000' || nit === '0000') {
            setMessage("Ingrese NIT o CI, para la factura");
            setAlerta(true);
            setError({ noNit: "Ingrese el NIT o CI, o ponga sin nit !!!" })
          } else if (nombre === '') {
            setMessage("Introduzca su nombre para la facturación ");
            setAlerta(true);
            setError({ noNombre: "Ingrese el Nombre por favor" })
          } else if (cliente === '') {
            setMessage("Quien Recojera EL PEDIDO?, INGRESE EL NOMBRE??")
            setAlerta(true);
            setError({ noCliente: "Ingrese el Nombre por favor" })
          }
        }

      } else {
        setMessage('Ingresar un número de celular valido .!');
        setAlerta(true);
      }
    } else {
      setMessage('Ingresa su número de celular, por favor .!');
      setAlerta(true);
    }
  }

  const datoFactura = (e) => {
    console.log(e.target.value);
    if (conFactura === false) {
      setConFactura(true);
      setNit('100001');
      setNombre('CLIENTE PARTICULAR');
      e.target.src = `/imagenes/nombre.png`;
      document.getElementById('btnSN').innerHTML = 'Colocar Nombre';
      setMessage("Cuando pone SIN NOMBRE, no llegara la factura a su correo, considere eso por favor ...")
      setAlerta(true);
    } else {
      setConFactura(false);
      setNit('');
      setNombre('');
      e.target.src = `/imagenes/sinNombre.png`
      document.getElementById('btnSN').innerHTML = 'Sin Nombre'
    }
  }
  const agregarACarrito = () => {
    cancelarTodo()
  }
  const nitIngresando = () => {
    var info = utils.getNameSucursal(localStorage.getItem("filtroSucursal"));
    if (nit.length != 0) {
      fetch(`/servidorSucursal/buscarDocumento`, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ info, nit })
      })
        .then(res => res.json())
        .then(data => {
          if (data.ok) {
            setNombre(data.ok.RAZON_SOCIAL);
            document.getElementById('correoCliente').value = data.ok.CORREO;
            if (data.ok.CELULAR) {
              setTelefono(data.ok.CELULAR.toString());
            }
          } else {
            msg.msgError("No se encontró ningun nombre asociado al NIT ingresado")
          }
        })
        .catch(err => {
          console.log(err);
          msg.msgError(err.message)
        });
    } else {
      msg.msgError("ingrese NIT o CI !!!")
    }
  }
  function getNumDespachos() {
    var info = utils.getNameSucursal(localStorage.getItem("filtroSucursal"));
    fetch(`/servidorSucursal/infoDespachoSucursal`, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ info })
    })
      .then(res => res.json())
      .then(data => {
        if (data.ok) {
          setListaDespacho(data.ok);
        } else {
          msg.msgError(data.error);
        }
      })
      .catch(err => {
        console.log(err);
        msg.msgError(err.message);
      });
  }
  function callbackBack() {
    if (tipoPedido === 'DOMICILIO' || tipoPedido == 'FEXCO') {
      navigate("/miPedido", { replace: true });
    } else if (tipoPedido === 'SUCURSAL') {
      navigate("/datoAdicional", { replace: true });
    }
  }

  function cambiarSucursal(e) {
    setSucursalSeleccionada(e.target.value);
  }

  async function enviarPedidoConfirmacion() {
    console.log(tipoPago);

    setError({});
    var infUser = JSON.parse(localStorage.getItem('infUser'))

    let estadoDespacho = 'L';

    if (infUser.estadoDespacho) {
      estadoDespacho = infUser.estadoDespacho;
    }

    if (infUser.correo == '' || tipoPedido === 'SUCURSAL') {
      infUser.correo = document.getElementById('correoCliente').value;
    }
    if (tipoPedido === 'DOMICILIO' || tipoPedido == 'FEXCO') {
      infUser.correo = document.getElementById('correoCliente').value;
    }
    if (validarCorreo(infUser.correo)) {
      setMostrarMensajeConfirmacion(false);
      setLoading(true);
      utilsCarrito.getTotalDetalleCompra()
      var detalles = [];
      for (var item of utilsCarrito.getCarritoDetalle()) {
        //delete item.tipo_despacho;
        delete item.precioT;
        item.tipo_despacho = estadoDespacho;
        detalles.push(item);
      }
      var variantes = []
      for (var item of utilsCarrito.getCarritoVariantes()) {
        //delete item.tipo_despacho;
        item.tipo_despacho = estadoDespacho;
        variantes.push(item);
      }
      var miPedido = {
        idTelefonico: 0,
        nit: nit,
        nombre: nombre,
        total: utilsCarrito.getTotalDetalleCompra(),
        tipoPago: tipoPedido === 'DOMICILIO' ? 'Q' : tipoPago,
        tipoPedido: tipoPedido === 'DOMICILIO' ? 'K' : tipoPedido == 'FEXCO' ? 'F' : 'R',
        recogera: tipoPedido === 'DOMICILIO' ? cliente : infUser.cliente,
        observaciones: (tipoPedido === 'DOMICILIO' || tipoPedido == 'FEXCO') ? observaciones : infUser.observaciones,
        para_hora: (tipoPedido === 'DOMICILIO' || tipoPedido == 'FEXCO') ? horaPedido : infUser.horaPedido,
        codigo_documento: conFactura ? 4 : 1,
        detalles: detalles,
        variantes: variantes,
        telefono: telefono,
        //debug: true,
        ...infUser,
      };
      console.log("Sucursal seleccionada", sucursalSeleccionada);
      if (tipoPedido === 'DOMICILIO') {
        delete miPedido.para_hora;
      } else if (tipoPedido == 'FEXCO') {
        delete miPedido.para_hora;
        miPedido.recogera = "";
        //miPedido.idSucursalDestino = localStorage.getItem('filtroSucursal');
        if (pedidoNormal) {
          miPedido.idSucursalDestino = localStorage.getItem('filtroSucursal');
        } else {
          miPedido.idSucursalDestino = sucursalSeleccionada;
        }
        miPedido.sucursal = utilsRecervas.getNombreSucursal(miPedido.idSucursalDestino);
        miPedido.servidorip = utilsRecervas.getIpservidor(miPedido.idSucursalDestino);
      } else {

        if (pedidoNormal) {
          miPedido.idSucursalDestino = localStorage.getItem('filtroSucursal');
        } else {
          miPedido.idSucursalDestino = sucursalSeleccionada;
        }

        miPedido.sucursal = utilsRecervas.getNombreSucursal(miPedido.idSucursalDestino);
        miPedido.servidorip = utilsRecervas.getIpservidor(miPedido.idSucursalDestino);

        //miPedido.idSucursalDestino = localStorage.getItem('filtroSucursal');
        //miPedido.sucursal = utilsRecervas.getNombreSucursal(miPedido.idSucursalDestino);
        //miPedido.servidorip = utilsRecervas.getIpservidor(miPedido.idSucursalDestino);
      }
      console.log(miPedido)
      localStorage.setItem('informacionCliente', JSON.stringify(miPedido));
      //setLoading(false);
     await realizarPedido(miPedido, tipoPago);
    } else {
      setMessage("Ingresar un correo valido por favor ... ")
      setAlerta(true);
    }
  }

  useEffect(() => {
    
    let informacionCliente = JSON.parse(localStorage.getItem('infUserRRRRR'));
    if (informacionCliente) {
      console.log("HAY INFORMACION DEL CLIENTE")
      console.log(informacionCliente)

      setNit(informacionCliente.nit)
      setNombre(informacionCliente.nombre)
      setTelefono(informacionCliente.telefono)

      if (informacionCliente.correo) {
        document.getElementById('correoCliente').value = informacionCliente.correo;
      }

    } else {
      console.log("NO HAY INFORMACION DEL CLIENTE")
    }

    let idSucursal = localStorage.getItem("idSucursal");
    setSucursalSeleccionada(idSucursal);

    let sucursalesAux = JSON.parse(localStorage.getItem('sucursales'));
    setSucursales(sucursalesAux)

    var t = localStorage.getItem('tipoPedido');
    if (t != undefined) {
      setTipoPedido(t);
    }

    let ciudadRegional = localStorage.getItem('ciudad');
    let sucursalRegional = ciudadRegional === '990' ? 9 : 45
    console.log(sucursalRegional)

    
    var hro = utilsRecervas.getHorarioSucursalRegional(regional, 9);
    console.log(restricciones_desactivadas, restricciones_desactivadas)

    
    


    if (hro != '') {
      console.log('quiero ver mi hro', hro);
      if (hro[10].indexOf('E') != -1) {
        setHayPagoe(true);
      } else {
        setHayPagoe(false);
      }
      if (hro[10].indexOf('Q') != -1) {
        setHayPagoqr(true);
      } else {
        setHayPagoqr(false);
      }
    }
    //getNumDespachos();
  }, []);

  useEffect(() => {
      const verificarHora = () => {
        let ciudadRegional = localStorage.getItem('ciudad');
        if (ciudadRegional === '991'){
            const ahora = new Date();
            const horaBolivia = new Date(
              ahora.toLocaleString('en-US', {
                timeZone: 'America/La_Paz'
              })
            );

            setHoraRegional(horaBolivia.getHours() >= 11);
        }
      };
      verificarHora();
      const intervalo = setInterval(verificarHora, 60000);
      return () => clearInterval(intervalo);
    }, []);

  return (
    <div className='fondoColor vh-100'>
      <Header pagina={5} title={"Mi Pedido"} callback={() => callbackBack()}></Header>
      <div className='container-fluid col-sm-12 col-md-6 col-xl-4 py-2 overflow-auto configOverFlow'>
        <div className='text-center textTitle'>
          <b>Muchas gracias por su pedido <i className="bi bi-emoji-laughing-fill"></i></b>
        </div>
        <div className='text-center textCard'>
          Datos para Facturar
        </div>
        <div className='container-fluid text-dark py-2'>
          <div className='row row-cols-2 g-2'>
            <div className='col col-8'>
              <div className="input-group">
                <input type="number"
                  className="form-control textInfo"
                  value={nit}
                  disabled={conFactura}
                  onChange={(e) => setNit(e.target.value)}
                  placeholder='NIT o CI' />
                <button className="btn text-light botonNaranja" type="button" onClick={nitIngresando} disabled={conFactura}>
                  <i className="fa-solid fa-magnifying-glass"></i>
                </button>
              </div>
              {error.noNit && <span className='badge bg-danger text-wrap'>{error.noNit}</span>}
              <div className='py-2'>
                <input type="text"
                  className="form-control textInfo"
                  value={nombre}
                  disabled={conFactura}
                  onChange={(e) => { setNombre(e.target.value) }}
                  placeholder='Nombre de Factura' />
                {error.noNombre && <span className='badge bg-danger text-wrap'>{error.noNombre}</span>}
              </div>

            </div>
            <div className='col col-4 my-auto text-center'>
              <button className='btn btn botonPlomo text-light ' id='btnSN' onClick={datoFactura}
                style={{ width: '90px', height: '78px', borderRadius: '17px' }}>
                Factura sin nombre
              </button>
              <div className="mb-2 d-none">
                <img src={`/imagenes/sinNombre.png `} className='d-none' id="sinNombre" onClick={datoFactura} width="90" height="90"></img>
              </div>
            </div>
          </div>
        </div>
        {tipoPedido === 'DOMICILIO' && <div className="container">
          <input type={tipoPedido === 'DOMICILIO' ? 'text' : "text"}
            className="form-control textInfo"
            value={cliente}
            onChange={(e) => { setCliente(e.target.value) }}
            placeholder={tipoPedido === 'DOMICILIO' ? 'Preguntar Por ?' : 'Nombre del Cliente'} />
          {error.noCliente && <span className='badge bg-danger text-wrap'>{error.noCliente}</span>}
        </div>}
        {(tipoPedido === 'DOMICILIO' || tipoPedido == 'FEXCO') &&
          <div className='container-fluid mt-2'>
            <textarea type="text"
              value={observaciones}
              className="form-control textInfo mb-2 borderEdit"
              placeholder='Ingrese alguna nota para el pedido'
              onChange={(e) => setObservaciones(e.target.value.toUpperCase())}
              style={{ height: '90px' }} />
          </div>}

        {!pedidoNormal && (
          <>
            <div className='container my-2'>
              <div className='text-center mb-2 textInicio'>
                Sucursal donde se realizará el pedido
              </div>

              <Form.Select value={sucursalSeleccionada}
                style={{ width: '140px' }}
                aria-label="Default select example"
                onChange={cambiarSucursal}
                className="d-block mx-auto"
              >
                {sucursales.map((sucursal) =>
                  sucursal.CALLCENTER_TELEFONOS != 'S' && sucursal.CALLCENTER_PRODUCCION != 'S' ? (
                    <option key={sucursal.ID_SUCURSAL} value={sucursal.ID_SUCURSAL}>
                      {sucursal.SUCURSAL}
                    </option>
                  ) : null
                )}
              </Form.Select>
            </div>
          </>
        )}

        <div className='container text-center my-4'>
          <div className='text-center textInicio'>
            Por favor dejenos un número de celular para notificarle.
          </div>
          <input type="number"
            value={telefono}
            onChange={(e) => setTelefono(e.target.value)}
            className="form-control textInfo mb-2 borderEdit"
            placeholder='Número de Celular' />
        </div>

        <div className='container text-center'>
          <div className='text-center textInicio'>
            Proporcione su correo para enviarle la factura (Opcional)
          </div>
          <input type="email"
            id='correoCliente'
            className="form-control textInfo mb-1 borderEdit"
            placeholder='ejemplo@gmail.com' />
        </div>

      </div>
      <div className='container-fluid floatBotones text-center' style={{ bottom: '4px' }}>
        <div className='container-fluid col-sm-12 col-md-6 col-xl-4 '>
          {generoQr === false && tipoPedido === 'DOMICILIO' &&
            <button className='rounded-pill w-100 btn text-white  botonNaranja '
              title='Siquiente Paso'
              onClick={() => enviarPedido('P')}>
              Confirmar y pagar por Qr <i className="bi bi-send-plus-fill"></i>
            </button>}
          {generoQr && tipoPedido === 'DOMICILIO' && <button className='rounded-pill btn text-white botones'
            onClick={() => generarCodigoQr()}>
            Reintentar <i className="bi bi-send-plus-fill"></i>
          </button>}

          {pedidoNormal && tipoPedido == 'SUCURSAL' && hayPagoe && !horaRegional &&(
            <>
              <button className='btn btn-sm w-100 rounded-pill text-white botonPlomo'
                onClick={() => enviarPedido('E')}>
                Solo Reservar
              </button>

              <div className='textCard text-center mb-4'>
                Solo se tomará previsiones para su pedido y deberá pagar en efectivo
              </div>
            </>
          )}

          {tipoPedido == 'SUCURSAL' && <button className='btn btn-sm w-100 rounded-pill text-white botonNaranja'
            onClick={() => enviarPedido('Q')} >
            Pagar con QR
          </button>}
          {tipoPedido == 'SUCURSAL' && <div className='textCard text-center mb-2'>
            Sú Pedido estará listo a la hora que índica
          </div>}
          {tipoPedido == 'FEXCO' && <button className='btn btn-sm w-100 rounded-pill text-white botonNaranja'
            onClick={() => enviarPedido('Q')} >
            Pagar con QR
          </button>}
        </div>
      </div>
      <MsgAlertas msg={message} show={alerta} callback={() => setAlerta(false)} />
      <PopupLoader loading={loading} />

      <Modal show={mostrarMensajeConfirmacion} contentClassName="bg-transparent "
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered>
        <Modal.Header bsPrefix="modal-header m-0 p-0">
          <div className='verPedidoButon w-100 text-center my-auto py-1'
            style={{ borderTopRightRadius: '10px', borderTopLeftRadius: '10px' }}>
            <div className='text-white textTitle'><i className="fa-solid fa-circle-exclamation"></i> NOTIFICACIÓN</div>
          </div>
        </Modal.Header>
        <Modal.Body bsPrefix="modal-body m-0 p-0 bg-light">
          <div className='container-fluid py-4'>
            <p className='textInfo text-center mb-1'>
              ¿Está segur@ de que desea continuar con esta forma de pago?
            </p>
          </div>
        </Modal.Body>
        <Modal.Footer bsPrefix="modal-footer text-center m-0 p-0 mx-auto bg-light w-100">

          <button className="btn btn-sm text-light botonPlomo" onClick={() => { setMostrarMensajeConfirmacion(false); }}>
            No <i className="fa-solid fa-thumbs-down"></i>
          </button>

          <button className="btn btn-sm text-light botonNaranja" onClick={() => { enviarPedidoConfirmacion(); }}>
            Si <i className="fa-solid fa-thumbs-up"></i>
          </button>

        </Modal.Footer>
      </Modal>

    </div>
  )
}
